import React, { FC } from 'react';
import { Copy } from './styles';

const CopyIcon: FC = ({ ...rest }) => {
	return <Copy {...rest} />;
};

export default CopyIcon;
